import Basic from '@/components/page/Basic.js'
import { Penanggalan, AxiosWithJar, Config } from '@/utility.js'

export default{
	extends: Basic,
	props:[],
	data:()=>({
        toggleIcon: false,
        clearing: {uncleared:[]},
		loading: { table:true },
        colors: ['#1F82E4','#F59B0E','#FC1608','#00B050'],

        options: {
            months:[
                {value:'1', name: 'Januari'},
                {value:'2', name: 'Februari'},
                {value:'3', name: 'Maret'},
                {value:'4', name: 'April'},
                {value:'5', name: 'Mei'},
                {value:'6', name: 'Juni'},
                {value:'7', name: 'Juli'},
                {value:'8', name: 'Agustus'},
                {value:'9', name: 'September'},
                {value:'10', name: 'Oktober'},
                {value:'11', name: 'November'},
                {value:'12', name: 'Desember'},
            ],
            years:[
                {value:'2021', name: '2021'},
                {value:'2022', name: '2022'},
                {value:'2023', name: '2023'},
                {value:'2024', name: '2024'},
            ],
        },

        month: ""+(Penanggalan().bulan-1),
        year: ""+Penanggalan().tahun,
        lastUpdate: '',
        minLengthDescription: 15,
        
	}),
	methods:{
	
        //used
		async loadUncleared() {
			let url = Config().apiURL + "/finance/dcreport?detail1=area&date-range-start=" + this.clearingStartDate + "&date-range-end=" + this.clearingEndDate + "&area=&status=UNCLEARED&type=SPBU"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.data.length) {
					this.clearing.uncleared = result.data.data;
				}
			})
		},

        toggleFullscreen() {
            //document.documentElement.requestFullscreen()
            var doc = window.document;
            var docEl = doc.documentElement;

            var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
            var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

            if(!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
                requestFullScreen.call(docEl);
                this.toggleIcon = true
            } else {
                cancelFullScreen.call(doc);
                this.toggleIcon = false
            }
        },


        setLocalPeriod(month, year) {
            if (localStorage.getItem("isPeriodSet") === null) {
                localStorage.setItem('isPeriodSet', true)  
                localStorage.setItem('month', month)  
                localStorage.setItem('year', year)    
            }
        },

        isLocalPeriodSet() {
            //if(localStorage.hasOwnProperty('isPeriodSet')) {
            if (localStorage.getItem("isPeriodSet") === null) {
                return false
            } else {
                return true
            }
        },

        capitalizeWord(originalText) {
            // Konversi huruf pertama menjadi huruf besar (kapital)
            // dan sisanya menjadi huruf kecil (huruf kecil)
            return originalText.charAt(0).toUpperCase() + originalText.slice(1).toLowerCase();
        },

        setDefaultPeriod() {
            // Mengecek apakah key sudah ada di localStorage
            if (localStorage.getItem('performanceDefaultMonth') !== null && localStorage.getItem('performanceDefaultYear') !== null) {
                //console.log('Period sudah ada di localStorage');
                let month = localStorage.getItem('performanceDefaultMonth')
                let year = localStorage.getItem('performanceDefaultYear')

                this.month = month
                this.year =  year
            } else {
                //console.log('period belum ada di localStorage');
            }
        },

	},
    computed: {
		clearingStartDate() {
			return Penanggalan().tahunSekarang;
		},
		clearingEndDate() {
			var today = new Date();			
			var dt = new Date(today.getTime() - ((1000*60*60*24) * (today.getDay() >= 4 ? 3 : (today.getDay() >= 1 ? 5 : 4))));
			return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
		}
    }
}